const colors = {
    active: '#2D79E0',
    deactivated: '#E3573A',
    driverless: '#999999',
    driving: '#42B783',
    resting: '#F7E264',
    default: '#999999',
}

const activeWorkingStates = [0, 1, 2, 3]
const deactivatedWorkingStates = [6, 7]
const restingWorkingStates = [0, 1, 8]

export default {
    data() {
        return {
            axRoadMode: 'default',
        }
    },
    watch: {
        $route(to) {
            this.setAxRoadMode(to.path)
        },
    },
    computed: {},
    methods: {
        setAxRoadMode(path) {
            if (path.match(/\/map(\/ax-road\/trucks|(?!\/ax-road))/)) {
                this.axRoadMode = 'assets'
            } else if (path.match(/\/map\/ax-road\/drivers/)) {
                this.axRoadMode = 'drivers'
            }
            // todo: add more ax-road modes
            return 'default'
        },
        getAxRoadAssetColor(tracker) {
            const sensorData = tracker?.asset_details?.sensor_data
            const workingState = sensorData?.selected_activity?.value
            const driverId = sensorData?.driver_id?.value
            const driverCardPresence = sensorData?.driver_1_card_presence?.value

            if (!driverId || !driverCardPresence || workingState === 8) {
                return colors.driverless
            }
            if (activeWorkingStates.includes(workingState)) {
                return colors.active
            }
            if (deactivatedWorkingStates.includes(workingState)) {
                return colors.deactivated
            }
            return colors.default
        },
        getAxRoadDriverColor(driver) {
            if (restingWorkingStates.includes(driver?.current_activity)) {
                return colors.resting
            }
            if (activeWorkingStates.includes(driver?.current_activity)) {
                return colors.driving
            }
            return colors.default
        },
    },
    created() {
        this.setAxRoadMode(this.$route.path)
    },
}
